export const paymentSources = {
    instaPaidAccount: 'InstaPaidAccount',
    instaPaidEurAccount: 'InstaPaidEurAccount',
    companyAccount: 'CompanyAccount'
};

// Payment combinations that route payouts through a named InstaPaid house
// account and therefore require an explicit house-account selection.
export const HOUSE_ACCOUNT_PAYMENT_COMBINATIONS = [
    'InstaPaid DKK',
    'InstaPaid EUR'
];

export const paymentProviders = {
    aiia: 'Aiia',
    danskeBank: 'DanskeBank'
};

export const approvalTypes = {
    manual: 'Manual',
    automatic: 'Automatic'
};

export const salaryProviders = {
    datevLodasFile: 'DatevLodasFile'
};

export const ENABLE_SHIFT_TYPES_FOR_PROVIDERS = [
    'Planday',
    'TitanPlan',
    'Staff',
    'Quinyx',
    'SameSystem',
    'WorkForce',
    'Workfeed'
];

export const AUTO_APPROVAL_TIME_PROVIDERS = [
    'Planday',
    'Staff',
    'Tamigo',
    'SameSystem',
    'TitanPlan',
    'Quinyx',
    'WorkForce',
    'Workfeed'
];
export const ALLOW_CONNECTION_TIME_REGISTRATION_EDIT = [
    'Planday',
    'Zenegy',
    'Tamigo',
    'SameSystem',
    'TitanPlan',
    'Staff',
    'Quinyx',
    'WorkForce',
    'Workfeed'
];

export const CREDENTIAL_BASED_AUTH_PROVIDERS = [
    'Planday',
    'Tamigo',
    'SameSystem',
    'TitanPlan',
    'Staff',
    'Quinyx',
    'WorkForce',
    'Workfeed'
];

export const OAUTH_BASED_AUTH_PROVIDERS = ['Zenegy'];

// Providers whose shifts are served from a cache that a background job refreshes
// on a schedule, so Backoffice needs a way to pull the latest shifts on demand.
export const MANUAL_SHIFTS_CACHE_REFRESH_PROVIDERS = ['Planday'];

export const PER_DEPARTMENT_TIPS_SALARY_TYPE_PROVIDERS = ['Zenegy', 'Intect'];

export const CREDENTIAL_BASED_PAYROLL_PROVIDERS = [
    'Intect',
    'ProLoen',
    'Epos',
    'Lessor',
    'DagrofaLon',
    'DataLon',
    'D365FinanceOperations',
    'DatevLodasFile'
];

// Supported document languages configuration
export const SUPPORTED_DOCUMENT_LANGUAGES = [
    {
        code: 'da',
        name: 'Danish',
        flag: '/src/icons/flags/denmark.svg'
    },
    {
        code: 'en',
        name: 'English',
        flag: '/src/icons/flags/uk.svg'
    }
    // Add more languages here as needed
    // {
    //     code: 'sv',
    //     name: 'Swedish',
    //     flag: '/src/icons/flags/sweden.svg'
    // }
] as const;
